const OrderSummaryTileViews = {
  Cart: "cart",
  Checkout: "checkout",
} as const;

export type OrderSummaryTileView =
  (typeof OrderSummaryTileViews)[keyof typeof OrderSummaryTileViews];

export default OrderSummaryTileViews;
